// onPrimary should take user back to first step (receipt validation) or prep for a new request
const SuccessModal = ({ onPrimary, receiptNo, message }) => {
  return (
    <div className="x-dialog">
      <div className="x-dialog-wrapper">
        <div className="x-dialog-form w-form">
          <div className="x-dialog-header">
            <div className="x-dialog-title for-action-icon" style={{ color: '#2e7d32' }}>
              ✔
            </div>
            {/* Close icon removed to drive a single clear action */}
          </div>
          <div className="x-dialog-body">
            <div className="x-form-wrapper">
              <div className="x-form-row">
                <div className="x-form-col" style={{ textAlign: 'center' }}>
                  <h2 style={{ marginTop: 0, color: '#2e7d32' }}>Request Received</h2>
                  <p style={{ fontSize: '15px', lineHeight: '1.5' }}>
                    Your e-Invoice request has been submitted successfully.
                  </p>
                  {receiptNo && (
                    <div
                      style={{
                        background: '#f1f8e9',
                        border: '1px solid #c5e1a5',
                        padding: '10px 14px',
                        borderRadius: '6px',
                        margin: '15px 0',
                        fontSize: '14px',
                      }}
                    >
                      <strong>Receipt No:</strong> {receiptNo}
                    </div>
                  )}
                  {message && <p style={{ fontSize: '14px', color: '#555' }}>{message}</p>}
                  <p style={{ fontSize: '13px', color: '#777' }}>
                    You will receive further communication (if required) from the contact
                    information provided.
                  </p>
                </div>
              </div>
              <div className="x-form-action" style={{ display: 'flex', justifyContent: 'center' }}>
                <button
                  type="button"
                  className="button-primary w-button"
                  style={{ background: '#1976d2', minWidth: '200px' }}
                  onClick={onPrimary}
                >
                  Request Another
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="x-dialog-overlay" />
      </div>
    </div>
  );
};

export default SuccessModal;
